// Appels API de l'espace chauffeur (functions/routes/driverapp.js).
// `s` = { uid, session } (cf session.js). Les erreurs HTTP remontent en
// exceptions axios : le composant lit `e.response.status` / `.data.error`.

import axios from "axios";
import { apiRoot } from "../../index";

const base = () => `${apiRoot}/api/v1/driverapp`;
const me = (s) => `${base()}/me/${encodeURIComponent(s.uid)}/${encodeURIComponent(s.session)}`;

export async function requestCode(uid, phone) {
  const res = await axios.post(`${base()}/auth/request-code`, { uid: uid || undefined, phone });
  return res.data;
}

export async function verifyCode(uid, phone, code) {
  const res = await axios.post(`${base()}/auth/verify`, { uid, phone, code });
  return res.data;
}

export async function loginWithLink(uid, linkId) {
  const res = await axios.post(`${base()}/auth/link`, { uid, linkId });
  return res.data;
}

export async function loginFromTrack(uid, token) {
  const res = await axios.post(`${base()}/auth/from-track`, { uid, token });
  return res.data;
}

export async function getMe(s) {
  const res = await axios.get(me(s));
  return res.data;
}

export async function getRides(s, from, to) {
  const params = {};
  if (from) params.from = from;
  if (to) params.to = to;
  const res = await axios.get(`${me(s)}/rides`, { params });
  return res.data;
}

export async function getOffers(s) {
  const res = await axios.get(`${me(s)}/offers`);
  return res.data;
}

export async function acceptOffer(s, bookingId) {
  const res = await axios.post(`${me(s)}/offers/${encodeURIComponent(bookingId)}/accept`);
  return res.data;
}

export async function declineOffer(s, bookingId) {
  const res = await axios.post(`${me(s)}/offers/${encodeURIComponent(bookingId)}/decline`);
  return res.data;
}

export async function pushSubscribe(s, subscription) {
  const res = await axios.post(`${me(s)}/push/subscribe`, { subscription });
  return res.data;
}

export async function pushUnsubscribe(s, endpoint) {
  const res = await axios.post(`${me(s)}/push/unsubscribe`, { endpoint });
  return res.data;
}

export async function logout(s) {
  try {
    await axios.post(`${me(s)}/logout`);
  } catch (e) {
    // la session locale est effacée quoi qu'il arrive
  }
}
